import React from "react";
import {
	Divider,
	Link,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import "./OrderDetails.css";
import { ASSETS_BASE_URL } from "../../config";
import { useSite } from "../../context/siteContext";
import { useNavigate } from "react-router-dom";

const OrderDetails = ({ orderData }) => {
	const { order, details, products } = orderData;
	console.log(orderData);
	const { selectedSiteCurrency, currencySymbol } = useSite();
	const navigate = useNavigate();

	const handleNavigateToProduct = (url) => {
		navigate(url);
	};

	const handleImgError = (e) => {
		const defaultImage = `${ASSETS_BASE_URL}/stock.png`;
		e.target.onerror = null; // Prevent infinite loop
		e.target.src = defaultImage; // Fallback to default image
	};
	return (
		<div className="order-details-section">
			<div className="left">
				<div className="section flex-space-between">
					<div className="flex-1">
						<Typography variant="body1" className="section-title">
							Shipping Address
						</Typography>
						<Divider className="divider" />
						<div className="shipping-address" style={{ padding: "10px 10px 10px 0" }}>
							<Typography variant="body1" className="mt-2">
								{details.shipping_name}
							</Typography>
							<Typography variant="body1">
								{details.shipping_street}, {details.shipping_city}, {details.shipping_state}{" "}
								{details.shipping_zip},
							</Typography>
							<Typography variant="body1">{details.shipping_country}</Typography>
						</div>
					</div>
					<div className="flex-1">
						<Typography variant="body1" className="section-title mt-2">
							Billing Address
						</Typography>
						<Divider className="divider" />
						<div className="billing-address" style={{ padding: "10px 10px 10px 0" }}>
							<Typography variant="body1" className="mt-2">
								{details.billing_name}
							</Typography>
							<Typography variant="body1">
								{details.billing_street}, {details.billing_city}, {details.billing_state}{" "}
								{details.billing_zip},
							</Typography>
							<Typography variant="body1">{details.billing_country}</Typography>
						</div>
					</div>
				</div>
				<div className="section">
					<Typography variant="body1" className="section-title">
						Additional {details.freight_number !== "" ? "Order" : "Quote"} Details
					</Typography>
					<Divider className="divider" />
					<div className="details flex-space-between">
						<div className="headings" style={{ padding: "10px 10px 10px 0" }}>
							<Typography variant="body1" className="mt-2 bold">
								PO Number:
							</Typography>
							<Typography variant="body1" className="bold">
								Expedited Shipping:
							</Typography>
						</div>
						<div className="headings-values" style={{ padding: "10px 10px 10px 0", minWidth: "20%" }}>
							<Typography
								variant="body1"
								sx={{
									fontSize: details.po_number === "" ? "0.875rem" : "1rem",
									fontStyle: details.po_number === "" ? "italic" : "normal",
									color: details.po_number === "" ? "#aaa" : "inherit",
								}}>
								{details.po_number || "N/A"}
							</Typography>

							<Typography
								variant="body1"
								sx={{
									fontSize: details.ship_complete === "" ? "0.875rem" : "1rem",
									fontStyle: details.ship_complete === "" ? "italic" : "normal",
									color: details.ship_complete === "" ? "#aaa" : "inherit",
								}}>
								{details.ship_complete || "N/A"}
							</Typography>
						</div>
					</div>
				</div>
				<div className="section full-width">
					<Typography variant="body1" className="section-title mt-2">
						{details.freight_number !== "" ? "Order Notes" : "Quote Notes"}
					</Typography>
					<Divider className="divider" />
					<Typography variant="body1" sx={{ padding: "10px 10px 10px 0" }}>
						{details.order_notes}
					</Typography>
				</div>
			</div>
			<div className="right">
				<div className="section">
					<Typography variant="body1" className="section-title">
						Product Details
					</Typography>
					<Divider className="divider" />
					<TableContainer className="product-details-container" style={{ padding: "10px 10px 10px 0" }}>
						<Table stickyHeader>
							<TableHead>
								<TableRow>
									<TableCell>Product Name</TableCell>
									<TableCell align="center">Quantity</TableCell>
									<TableCell>Price</TableCell>
									<TableCell align="right">Total</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{products.map((item, index) => (
									<TableRow key={index} className="product-row">
										<TableCell className="product-cell">
											<img
												src={`${ASSETS_BASE_URL}/ProductImages/TMB/${item.productsData.product_number}.png`}
												alt={item.productsData.product_name}
												onError={handleImgError}
												className="product-image"
											/>
											<Link
												underline="hover"
												sx={{ cursor: "pointer" }}
												onClick={() => {
													const url = `/machines/${item.productsData.machine_id}/${item.productsData.product_id}`;
													handleNavigateToProduct(url);
												}}>
												{item.productsData.product_name}
											</Link>
										</TableCell>
										<TableCell align="center">x {item.product_quantity}</TableCell>
										<TableCell>
											{currencySymbol}
											{parseFloat(item.product_price).toFixed(2)}
										</TableCell>
										<TableCell align="right">
											{currencySymbol}
											{parseFloat(item.product_total).toFixed(2)}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
							<TableFooter className="product-footer">
								<TableRow className="product-footer-row">
									<TableCell colSpan={3} align="right">
										Subtotal:
									</TableCell>
									<TableCell align="right">
										{currencySymbol}
										{products
											.reduce((acc, item) => acc + parseFloat(item.product_total), 0)
											.toFixed(2)}
									</TableCell>
								</TableRow>
								{/* <TableRow className="product-footer-row">
									<TableCell colSpan={3} align="right">
										Taxes:
									</TableCell>
									<TableCell align="right">
										{currencySymbol}
										{parseFloat(order.order_taxes).toFixed(2)}
									</TableCell>
								</TableRow>
								<TableRow className="product-footer-row">
									<TableCell colSpan={3} align="right">
										Discount:
									</TableCell>
									<TableCell align="right">
										{currencySymbol}
										{parseFloat(order.order_discounts).toFixed(2)}
									</TableCell>
								</TableRow>
								<TableRow className="product-footer-row">
									<TableCell colSpan={3} align="right">
										Shipping:
									</TableCell>
									<TableCell align="right">
										{currencySymbol}
										{parseFloat(order.order_shipping_cost).toFixed(2)}
									</TableCell>
								</TableRow> */}
								<TableRow className="product-total-row">
									<TableCell colSpan={3} align="right">
										Total:
									</TableCell>
									<TableCell align="right">
										{currencySymbol}
										{products
											.reduce((acc, item) => acc + parseFloat(item.product_total), 0)
											.toFixed(2)}
									</TableCell>
								</TableRow>
							</TableFooter>
						</Table>
					</TableContainer>
				</div>
			</div>
		</div>
	);
};

export default OrderDetails;
